/**
 * Simple Theme System
 * Manual theme selection for different customers
 */

// Available themes
export const THEMES = {
  CUSTOMER_1: 'cus-1',
  CUSTOMER_2: 'cus-2', 
  CUSTOMER_3: 'cus-3',
  DEFAULT: 'default',
};

// Theme configurations
export const themeConfigs = {
  [THEMES.DEFAULT]: {
    name: 'Default Theme',
    colors: {
      primary: 'hsl(221.2, 83.2%, 53.3%)', // Blue
      primaryForeground: 'hsl(210, 40%, 98%)',
      secondary: 'hsl(210, 40%, 96.1%)',
      accent: 'hsl(210, 40%, 96.1%)',
      destructive: 'hsl(0, 84.2%, 60.2%)',
      // Footer-specific colors
      footerBg: 'hsl(220, 85%, 25%)', // Darker blue for footer
      footerText: 'hsl(210, 40%, 98%)',
    }
  },
  [THEMES.CUSTOMER_1]: {
    name: 'Customer 1 - Blue Theme',
    colors: {
      primary: 'hsl(217, 91%, 60%)', // Bright Blue
      primaryForeground: 'hsl(210, 40%, 98%)',
      secondary: 'hsl(214, 95%, 93%)',
      accent: 'hsl(214, 95%, 93%)',
      destructive: 'hsl(0, 84.2%, 60.2%)',
      // Footer-specific colors
      footerBg: 'hsl(215, 88%, 30%)', // Darker bright blue
      footerText: 'hsl(210, 40%, 98%)',
    }
  },
  [THEMES.CUSTOMER_2]: {
    name: 'Customer 2 - Red Theme',
    colors: {
      primary: 'hsl(0, 72%, 51%)', // Red
      primaryForeground: 'hsl(0, 0%, 98%)',
      secondary: 'hsl(0, 68%, 95%)',
      accent: 'hsl(0, 68%, 95%)',
      destructive: 'hsl(0, 84.2%, 60.2%)',
      // Footer-specific colors
      footerBg: 'hsl(0, 75%, 35%)', // Darker red
      footerText: 'hsl(0, 0%, 98%)',
    }
  },
  [THEMES.CUSTOMER_3]: {
    name: 'Customer 3 - Green Theme',
    colors: {
      primary: 'hsl(142, 76%, 36%)', // Green
      primaryForeground: 'hsl(0, 0%, 98%)',
      secondary: 'hsl(138, 76%, 95%)',
      accent: 'hsl(138, 76%, 95%)',
      destructive: 'hsl(0, 84.2%, 60.2%)',
      // Footer-specific colors
      footerBg: 'hsl(142, 78%, 25%)', // Darker green
      footerText: 'hsl(0, 0%, 98%)',
    }
  },
};

// Get current theme - MANUAL SELECTION FOR EACH CUSTOMER
export const getCurrentTheme = () => {
  // CHANGE THIS LINE FOR DIFFERENT CUSTOMERS:
    return THEMES.CUSTOMER_1;  // theme-cus-1 Blue
   // return THEMES.CUSTOMER_2;  // theme-cus-2 - Red
  // return THEMES.CUSTOMER_3;    // theme-cus-3 - Green
  // return THEMES.DEFAULT;     // theme-default
};

// Apply theme directly
export const applyTheme = (themeName) => {
  const theme = themeConfigs[themeName];
  if (!theme) {
    console.warn(`Theme "${themeName}" not found`);
    return;
  }
  
  const root = document.documentElement;
  
  // Apply CSS custom properties
  Object.entries(theme.colors).forEach(([key, value]) => {
    const cssVar = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    root.style.setProperty(`--${cssVar}`, value);
  });
  
  // Add theme class to body
  document.body.className = document.body.className.replace(/theme-[\w-]+/g, '');
  document.body.classList.add(`theme-${themeName}`);
};



// Initialize theme system
export const initializeTheme = () => {
  const currentTheme = getCurrentTheme();
  applyTheme(currentTheme);
  return currentTheme;
};

const themes = {
  THEMES,
  themeConfigs,
  getCurrentTheme,
  applyTheme,
  initializeTheme,
};

export default themes;
